import React, { ReactNode } from 'react';

import './filters.css';

type Props = {
  children?: ReactNode;
};

const FiltersTitleClean = ({ children }: Props) => {
  return <div styleName="filters-title-clean">{children}</div>;
};

export default FiltersTitleClean;
